<template>
    <p class="page-text page-text--sm grey-9--text line-height-15">{{ startsAt }} ~ {{ endsAt }} {{ daysLeft }}</p>
</template>

<script>
import dayjs from "dayjs";

const days = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: {
        item: { type: Object, default: () => ({}) },
    },
    computed: {
        startsAt() {
            let { startsAt } = this.item?.application || {};
            return startsAt ? `${dayjs(startsAt).format("YYYY.MM.DD")}(${days[dayjs(startsAt).day()]})` : null;
        },
        endsAt() {
            let { endsAt } = this.item?.application || {};
            return endsAt ? `${dayjs(endsAt).format("YYYY.MM.DD")}(${days[dayjs(endsAt).day()]})` : null;
        },
        daysLeft() {
            let { daysLeft } = this.item?.application || {};
            if (Number.isNaN(daysLeft)) return "상시모집";

            if (daysLeft < 0) return `D${daysLeft}`;
            if (daysLeft == 0) return "D-Day";
            if (daysLeft > 0) return "마감";
        },
    },
};
</script>

<style>
</style>